exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table th, .table td {\n  border-top: 0px solid #c2cfd6 !important; }\n\n.table th, .table td {\n  padding: 0.2rem !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/document-audit-modal/document-audit-modal.component.scss
// module id = ../../../../../src/app/document-audit-modal/document-audit-modal.component.scss
// module chunks = main